<template>
  <div class="flex flex-row items-center justify-between w-full px-32">
    <button-el
        class="content bold"
        text="global.play"
        icon="square"
        backgroundColor="success"
        @click.native="$emit('playVideo')"
    />

    <button-el
        class="content bold"
        text="global.pause"
        icon="square"
        backgroundColor="success"
        @click.native="$emit('pauseVideo')"
    />

    <button-el
        class="content bold"
        text="global.restart"
        icon="square"
        backgroundColor="success"
        @click.native="$emit('resetView')"
    />
  </div>
</template>

<script>
import Button from '@/components/generic/Button';

export default {
  components: {
    ButtonEl: Button
  },
  props: {
    
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>